import { useTranslation } from 'react-i18next'
import {
  Button,
  ButtonBlock,
  ContentBlock,
  Font,
  List,
} from '@politechdev/blocks-design-system'
import humanizeString from 'humanize-string'
import { Timestamp } from 'components/Time/Timestamp'
import { formatDisplayName } from 'utils/formatting'
import { PerformanceReviewItem } from 'performanceReviews/types'
import { Link, useLocation } from 'react-router-dom'

const ReviewItem = ({ review }: { review: PerformanceReviewItem }) => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <List.Item>
      <ContentBlock>
        <Font.Copy>{review.canvasser.full_name}</Font.Copy>
        <Font.Copy variant="hint">
          <Timestamp
            dateTime={review.created_at}
            formatOptions={{ dateStyle: 'medium' }}
          />
        </Font.Copy>
      </ContentBlock>
      <ContentBlock>
        <Font.Copy>{humanizeString(review.status)}</Font.Copy>
        <Font.Copy variant="hint">
          {review.status === 'ready_for_review'
            ? t(`Assigned to {{userName}}`, {
                userName: formatDisplayName(review.assigned_to_user),
              })
            : t(`Requested by {{userName}}`, {
                userName: formatDisplayName(review.requested_by_user),
              })}
        </Font.Copy>
      </ContentBlock>
      <ButtonBlock justify="right">
        <Link to={`${location.pathname}/${review.id}`}>
          <Button.Secondary>{t('View')}</Button.Secondary>
        </Link>
      </ButtonBlock>
    </List.Item>
  )
}

export default ReviewItem
